import React from 'react';
import { OFFER_ANCHOR } from '../../data/content';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  external?: boolean;
  size?: 'md' | 'lg';
  className?: string;
}
const sizes: Record<'md' | 'lg', string> = {
  md: 'px-4 py-2.5 text-[0.82rem] sm:text-sm',
  lg: 'px-5 py-3 text-[0.92rem] sm:text-lg md:text-xl'
};
export function CtaButton({
  children,
  href = OFFER_ANCHOR,
  external = false,
  size = 'md',
  className = ''
}: CtaButtonProps) {
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`inline-flex w-full max-w-xl items-center justify-center rounded-lg border-b-4 border-gold-dark bg-gold text-center font-display uppercase leading-tight tracking-wide text-carbon shadow-[0_6px_20px_rgba(201,154,74,0.28)] transition-colors duration-150 ease-soft hover:bg-gold-dark ${sizes[size]} ${className}`} data-id="element-174" data-mp="1qvusrd9zocbp">
      {children}
    </a>;
}